import { useCallback } from 'react';

import { CircleSlash, Pencil } from 'lucide-react';
import { useFormContext } from 'react-hook-form';

import { Button } from '@/_components';

import type { EditButtonProps } from './type';

export function EditButton({ edit: [isEditing, editing] }: EditButtonProps) {
  const { reset, formState } = useFormContext();

  const toggleEdit = useCallback(() => {
    if (isEditing) {
      reset(formState.defaultValues, { keepTouched: false, keepDirty: false, keepDirtyValues: false });
    }
    editing.toggle();
  }, [editing, isEditing, reset, formState]);

  return (
    <Button
      icon={isEditing ? CircleSlash : Pencil}
      as={isEditing ? 'outline' : 'contained'}
      iconClassName="xs:block hidden"
      onClick={toggleEdit}
      size="sm"
    >
      {isEditing ? 'Cancel' : 'Edit'}
    </Button>
  );
}
